import { gql } from "@apollo/client"

export const DeleteMarketer = gql`
mutation DeleteMarketer($deleteMarketerId: ID!) {
  deleteMarketer(id: $deleteMarketerId) {
    status
  }
}
`